/* Product gallery: one large image, arrows, thumbnail strip, hover zoom.
   Loaded only on the product template. Without JS the stage is still a native
   horizontal scroller, so every image stays reachable by swipe and by scrollbar. */

(() => {
  const fine = window.matchMedia('(pointer: fine)').matches;
  const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const stage = gallery.querySelector('[data-gallery-stage]');
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const prev = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    if (!stage || slides.length < 1) return;

    let index = 0;

    const behavior = still ? 'auto' : 'smooth';

    const goTo = (i) => {
      index = Math.max(0, Math.min(slides.length - 1, i));
      stage.scrollTo({ left: slides[index].offsetLeft - stage.offsetLeft, behavior });
    };

    const paint = () => {
      thumbs.forEach((t, i) => t.setAttribute('aria-current', String(i === index)));
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    };

    if (prev) prev.addEventListener('click', () => goTo(index - 1));
    if (next) next.addEventListener('click', () => goTo(index + 1));
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => goTo(i)));

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            index = slides.indexOf(entry.target);
            paint();
          });
        },
        { root: stage, threshold: 0.6 }
      );
      slides.forEach((slide) => io.observe(slide));
    }

    paint();

    /* Hover zoom - pointer devices only, and never under reduced motion. */
    if (!fine || still) return;

    gallery.querySelectorAll('[data-zoom]').forEach((frame) => {
      const img = frame.querySelector('img');
      if (!img) return;
      const scale = Number(frame.getAttribute('data-zoom')) || 2;

      const move = (event) => {
        const box = frame.getBoundingClientRect();
        const x = ((event.clientX - box.left) / box.width) * 100;
        const y = ((event.clientY - box.top) / box.height) * 100;
        img.style.transformOrigin = `${x}% ${y}%`;
        img.style.transform = `scale(${scale})`;
      };

      const reset = () => {
        img.style.transform = '';
        img.style.transformOrigin = '';
      };

      frame.addEventListener('mouseenter', move);
      frame.addEventListener('mousemove', move);
      frame.addEventListener('mouseleave', reset);
    });
  });
})();
